<template>
  <div
    class="machine-maps"
    style="
      position: absolute;
      top: 0;
      width: 98%;
      height: 95%;
      background-color: var(--vtm-surface);
      padding: 1%;
      border-radius: 10px;
    "
    v-loading="fullscreenLoading"
  >
    <div id="mapBox" style="width: 100%; height: 100%; text-align: center">
      {{ $t("user.MachineMaps.588934-0") }}
    </div>
    <!-- 右侧设备栏目（hub 内嵌地图视图时隐藏，仅展示设备位置） -->
    <div
      v-if="!mapOnly"
      v-loading="rightLoading"
      style="position: absolute; top: 0; right: 0; height: 100%; background-color: var(--vtm-surface); border-radius: 10px"
    >
      <div
        style="width: 310px; height: 40px; line-height: 40px; text-align: center; font-size: 14px; font-weight: bold"
      >
        {{ $t("searchRenewalRecord.sxkz") }}
      </div>
      <div style="width: 310px; display: flow-root; padding-bottom: 10px; border-bottom: 1px solid var(--vtm-line)">
        <el-row :gutter="20" style="margin: 0">
          <el-col :span="24">
            <el-input
              size="medium"
              :placeholder="$t('machine.equipmentNo')"
              autocomplete="off"
              v-model="search.equipmentNo"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 0; margin-top: 10px">
          <el-col :span="24">
            <el-input
              size="medium"
              :placeholder="$t('machine.name')"
              autocomplete="off"
              v-model="search.equipmentName"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 0; margin-top: 10px">
          <el-col :span="12">
            <el-button @click="handleSearch" size="small" type="primary" icon="el-icon-search" style="width: 70%">{{
              $t("common.search")
            }}</el-button>
          </el-col>
          <el-col :span="12" style="padding-left: 0; text-align: right">
            <el-button @click="handleReset" size="small" style="width: 70%" icon="el-icon-refresh-right">{{
              $t("common.reset")
            }}</el-button>
          </el-col>
        </el-row>
      </div>
      <form :action="control.url" method="post" target="_blank" style="display: none">
        <input name="c" :value="control.remoteId" />
        <input name="pass" :value="control.remoteCode" />
        <input name="dn" :value="'Reyeah'" />
        <input name="lang" :value="'0'" />
        <button ref="btnForm" type="submit">
          {{ $t("user.MachineMaps.588934-1") }}
        </button>
      </form>
      <div
        ref="zuoceDiv"
        style="width: 100%; height: 74%; display: flow-root; overflow-y: scroll; cursor: pointer; padding-top: 3%"
      >
        <div v-for="(item, index) in showPositions" :key="index" style="width: 311px; display: flow-root">
          <div v-if="index > 0" style="width: 310px; border-bottom: 1px dashed var(--vtm-line); margin: 10px auto"></div>
          <div style="width: 100%; display: flex; justify-content: center; align-items: center; position: relative">
            <img
              @click="handleShow(index, 0, item['equipmentNo'])"
              src="../../../assets/img/left-s.png"
              style="width: 20px; height: 20px; display: block; margin-left: 10px"
            />
            <el-drawer
              :visible.sync="item.show"
              direction="rtl"
              :destroy-on-close="true"
              :modal="false"
              :show-close="false"
              :withHeader="false"
              size="100%"
            >
              <div style="width: 100%; height: 100%; display: flow-root">
                <el-row :gutter="20" style="font-size: 14px; margin: 0; height: 100%">
                  <el-col :span="24" style="height: 100%">
                    <div
                      style="
                        display: flex;
                        width: 100%;
                        height: 100%;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                      "
                    >
                      <div style="display: flow-root">
                        <div style="display: flow-root; width: 100%">
                          <!-- 远程控制按钮 -->
                          <template v-if="item.mqState === 1">
                            <template v-if="item.remoteCode && item.remoteId">
                              <el-popconfirm
                                :title="$t('common.yckongzhi')"
                                :confirm-button-text="$t('common.definite')"
                                :cancel-button-text="$t('common.cancel')"
                                @confirm="handleControl(item, index)"
                              >
                                <el-button slot="reference" size="mini" class="control-btn">{{
                                  $t("common.yckz")
                                }}</el-button>
                              </el-popconfirm>
                            </template>
                            <el-button v-else @click="handleControl(item, index)" size="mini" class="control-btn">{{
                              $t("common.yckz")
                            }}</el-button>
                          </template>
                          <el-tooltip v-else :content="$t('common.machineOffline')" placement="top">
                            <el-button size="mini" class="control-btn" disabled>{{
                              $t("common.yckz")
                            }}</el-button>
                          </el-tooltip>
                          <!-- 开启网络按钮 -->
                          <el-popconfirm
                            title="Turn on Ethernet"
                            :confirm-button-text="$t('common.definite')"
                            :cancel-button-text="$t('common.cancel')"
                            @confirm="handleOpenNetwork(item)"
                          >
                            <el-button slot="reference" size="mini" class="network-btn network-btn--open"
                              >Turn on Ethernet</el-button
                            >
                          </el-popconfirm>
                          <!-- 关闭网络按钮 -->
                          <el-popconfirm
                            title="Turn off Ethernet"
                            :confirm-button-text="$t('common.definite')"
                            :cancel-button-text="$t('common.cancel')"
                            @confirm="handleCloseNetwork(item)"
                          >
                            <el-button slot="reference" size="mini" class="network-btn network-btn--close"
                              >Turn off Ethernet</el-button
                            >
                          </el-popconfirm>
                          <!-- <el-button
                            type="primary"
                            @click="handleUnlocking(item)"
                            size="mini"
                            style="margin: 0 10px 10px 0; border: 0; font-weight: bold; padding: 7px; float: left;"
                            >{{ $t("common.sbkaisuo") }}</el-button
													> -->
                        </div>
                        <!--
                          <div style="display: flow-root; width: 100%">
                          <el-button
                            @click="handleSendLogMQ(item['equipmentNo'], 1)"
                            size="mini"
                            style="
                              margin: 0 10px 10px 0;
                              background-color: #c0ff53;
                              border: 0;
                              color: #525252;
                              font-weight: bold;
                              padding: 7px;
                              float: left;
                            "
                            >{{ $t("common.kernelrz") }}</el-button
                          >
                          <el-button
                            type="primary"
                            @click="handleSendLogMQ(item['equipmentNo'], 2)"
                            size="mini"
                            style="margin: 0 10px 10px 0; border: 0; font-weight: bold; padding: 7px; float: left"
                            >{{ $t("common.dskgj") }}</el-button
                          >
                          <el-button
                            type="primary"
                            @click="handleSendLogMQ(item['equipmentNo'], 3)"
                            size="mini"
                            style="margin: 0 10px 10px 0; border: 0; font-weight: bold; padding: 7px; float: left"
                            >{{ $t("common.azrizhi") }}</el-button
                          >
                          <el-button
                            type="danger"
                            @click="handlerReStart(item['equipmentNo'], '2', item)"
                            size="mini"
                            style="margin: 0 10px 10px 0; border: 0; font-weight: bold; padding: 7px; float: left"
                            >{{ $t("user.MachineMaps.588934-2") }}</el-button
                          >
                          <el-button
                            type="danger"
                            @click="handlerReStart(item['equipmentNo'], '1', item)"
                            size="mini"
                            style="margin: 0 10px 10px 0; border: 0; font-weight: bold; padding: 7px; float: left"
                            >{{ $t("user.MachineMaps.588934-3") }}</el-button
                          >
                          <el-button size="mini" style="margin: 0 10px 10px 0; background-color: #FF9F24;
                          border: 0; color: #525252; font-weight: bold;
                          padding: 7px; float: left;">{{$t('common.xtyuyan')}}</el-button>
                        </div> -->
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-drawer>
            <div style="width: 100%; height: 100%; display: flow-root">
              <el-row :gutter="20" style="margin: 0; font-size: 14px">
                <el-col :span="24">
                  <span style="font-weight: bold">{{ $t("machine.name") }}：</span>
                  <span>{{ item.equipmentName }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin: 0; font-size: 14px">
                <el-col :span="24">
                  <span style="font-weight: bold">{{ $t("machine.equipmentNo") }}：</span>
                  <span class="vtm-mono">{{ item.equipmentNo }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin: 0; font-size: 14px">
                <el-col :span="24">
                  <span style="font-weight: bold">{{ $t("user.nickName") }}：</span>
                  <span>{{ item.nickName }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin: 0; font-size: 14px">
                <el-col
                  :span="24"
                  style="
                    display: -webkit-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                  "
                >
                  <span style="font-weight: bold">{{ $t("machine.position") }}：</span>
                  <span>{{ item.locale }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin: 0; font-size: 14px">
                <el-col :span="24">
                  <span style="font-weight: bold">{{ $t("machineRecord.state") }}：</span>
                  <span v-if="item.mqState == 1" class="vtm-pill vtm-pill--ok">{{ $t("machineRecord.online") }}</span>
                  <span v-else-if="item.mqState == 0" class="vtm-pill vtm-pill--crit">{{ $t("machineRecord.unline") }}</span>
                  <span v-else>-</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin: 0; font-size: 14px">
                <el-col :span="24">
                  <span style="font-weight: bold">{{ $t("machineOrder.allPurchaseNum") }}：</span>
                  <span class="vtm-num">{{ item.totalNum }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin: 0; font-size: 14px">
                <el-col :span="24">
                  <span style="font-weight: bold">{{ $t("machineOrder.allDuePrice") }}：</span>
                  <span class="vtm-num">{{ item.totalSales }}</span>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin: 0; font-size: 14px">
                <el-col :span="24">
                  <span style="font-weight: bold">{{ $t("machine.onlineDuration") }}：</span>
                  <span>{{ item.mqLen }}</span>
                </el-col>
              </el-row>
            </div>
            <img
              v-if="!item.show"
              @click="handleShow(index, 1, item['equipmentNo'])"
              src="../../../assets/img/right-s.png"
              style="width: 16px; height: 16px; display: block; margin-right: 10px"
            />
            <img
              v-if="item.show"
              @click="handleShow(index, 1, item['equipmentNo'])"
              src="../../../assets/img/right-s-f.png"
              style="width: 16px; height: 16px; display: block; margin-right: 10px"
            />
          </div>
        </div>
        <div v-if="isShow" style="margin-top: 20px; text-align: center">
          {{ $t("user.MachineMaps.588934-4") }}
        </div>
      </div>
    </div>
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('machineConfig.yhyanz')"
      :visible.sync="dialogSmsVisible"
      width="305px"
      custom-class="SmsVerify"
      :before-close="handleVerifySmsClose"
      :close-on-click-modal="false"
    >
      <div>
        <p>{{ $t("machineConfig.yanztips") }}</p>
        <el-select v-model="verifyvalue" style="margin: 10px 0" size="small">
          <el-option
            v-for="(vers, index) in verifyset"
            :key="index"
            :label="vers['name']"
            :value="vers['value']"
          ></el-option>
        </el-select>
        <template v-if="issend">
          <p style="margin-top: 5px; color: var(--vtm-ok)">
            {{ $t("machineConfig.tips2") }}
          </p>
        </template>
        <div style="display: flex; align-items: center; margin-top: 5px">
          <el-input
            v-model="smscode"
            maxlength="6"
            :placeholder="$t('machineConfig.psmsemail')"
            style="margin-right: 15px"
            size="small"
          ></el-input>
          <el-button
            v-if="smscode && issend"
            type="primary"
            size="small"
            @click="handlerVerifySms"
            :loading="smsloading"
            >{{ $t("machineConfig.yanzhen") }}</el-button
          >
          <template v-else>
            <el-button v-if="!issend" type="primary" size="small" @click="handlerSendSms" :loading="smsloading">{{
              $t("machineConfig.sendbtn")
            }}</el-button>
            <el-button v-else type="primary" size="small" disabled
              >{{ $t("machineConfig.sendbtn") }}({{ miao }}s)</el-button
            >
          </template>
        </div>
        <div style="margin-top: 15px; color: var(--vtm-crit); font-size: 12px">
          {{ $t("machineConfig.tips1") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { Loader } from "@googlemaps/js-api-loader";
  import { MarkerClusterer } from "@googlemaps/markerclusterer";
  let marker = null;
  let positions = [];
  export default {
    name: "MachineMaps",
    props: {
      // hub 内嵌时仅显示地图（隐藏右侧设备选择/控制面板）
      mapOnly: { type: Boolean, default: false }
    },
    data() {
      return {
        longitude: "",
        latitude: "",
        fullscreenLoading: false,
        rightLoading: true,
        table: false,
        search: {
          equipmentNo: "",
          equipmentName: ""
        },
        pageIndex: 1,
        pageSize: 10,
        showPositions: [],
        count: 0,
        isShow: false,
        control: {
          remoteCode: "",
          remoteId: "",
          remoteStatus: 0,
          url: ""
        },
        //  开锁验证
        dialogSmsVisible: false,
        issend: false,
        smscode: "",
        smsloading: false,
        miao: 180,
        verifytype: "",
        verifyvalue: "",
        verifyset: [],
        localitem: {},
        // remote接口调用五次失败后就显示失败
        countError: 0,
        nowRemoteInfo: {}
      };
    },
    mounted() {
      let _self = this;
      //  监听设备列表滑动效果（仅在展示设备面板时）
      if (_self.$refs.zuoceDiv) {
        _self.$refs.zuoceDiv.addEventListener("scroll", this.scroll);
      }
      //  初始化地图
      _self.initMap();
    },
    methods: {
      // 重启板子功能
      async handlerReStart(equipmentNo, type) {
        await this.$confirm(
          type === "2" ? this.$t("user.MachineMaps.588934-5") : this.$t("user.MachineMaps.588934-6"),
          {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          }
        );
        this.$api
          .request(this.$url.UserMachine.reStartBoard, this.$method.post, {
            equipmentNo,
            type
          })
          .then(res => {
            this.$notify({
              title: this.$t("common.tip"),
              message: res.msg,
              type: res.code === 0 ? "success" : "warning"
            });
          })
          .catch(() => {
            this.$notify({
              title: this.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      handleUnlocking(item) {
        let _self = this;
        _self.localitem = item;
        if (_self.localitem.verify && _self.localitem.verify.length > 0) {
          let verify = _self.localitem.verify;
          for (let i = 0; i < verify.length; i++) {
            if (verify[i]["type"] == "email") {
              let email = verify[i]["value"];
              let splitted = email.split("@");
              let email1 = splitted[0];
              let avg = email1.length / 2;
              email1 = email1.substring(0, email1.length - avg);
              let email2 = splitted[1];
              let emailtm = email1 + "***@" + email2;
              verify[i]["name"] = emailtm + " (" + _self.$t("machineConfig.email") + ")";
            } else if (verify[i]["type"] == "phone") {
              let userPhone = verify[i]["value"].replace(/(\d{3})\d*(\d{4})/, "$1****$2");
              verify[i]["name"] = userPhone + " (" + _self.$t("machineConfig.phone") + ")";
            }
          }
          _self.verifyset = verify;
          _self.verifyvalue = verify[0]["value"];
        }
        _self.dialogSmsVisible = true;
      },
      handlerSendSms() {
        let _self = this;
        let verifyset = _self.verifyset;
        let verifytype = "";
        for (let i = 0; i < verifyset.length; i++) {
          if (_self.verifyvalue == verifyset[i]["value"]) {
            verifytype = verifyset[i]["type"];
          }
        }
        _self.verifytype = verifytype;
        _self.smsloading = true;
        _self.$api
          .request(_self.$url.UserMachine.getCode, _self.$method.post, {
            equipmentNo: _self.localitem.equipmentNo,
            equipmentName: _self.localitem.name,
            type: verifytype,
            verify: _self.verifyvalue
          })
          .then(res => {
            _self.smsloading = false;
            if (parseInt(res.code) == 0) {
              _self.issend = true;
              let dsq = window.setInterval(function () {
                if (_self.miao <= 1) {
                  window.clearInterval(dsq);
                  _self.issend = false;
                  _self.miao = 180;
                  return false;
                }
                _self.miao = parseInt(_self.miao) - 1;
                if (_self.miao < 10) {
                  _self.miao = "0" + _self.miao;
                }
              }, 1000);
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            _self.smsloading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: res.msg,
              type: "warning"
            });
          });
      },
      handlerVerifySms() {
        let _self = this;
        if (!_self.smscode) {
          _self.$message({
            message:
              _self.verifytype == "email" ? _self.$t("machineConfig.ppsmsemail") : _self.$t("machineConfig.ppsmsphone"),
            type: "warning"
          });
          return false;
        }
        _self.smsloading = true;
        _self.$api
          .request(_self.$url.UserMachine.validCode, _self.$method.post, {
            equipmentNo: _self.localitem.equipmentNo,
            verify: _self.verifyvalue,
            code: _self.smscode,
            unLock: 1
          })
          .then(res => {
            _self.smsloading = false;
            if (parseInt(res.code) == 0) {
              _self.dialogSmsVisible = false;
              return false;
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            _self.smsloading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: res.msg,
              type: "warning"
            });
          });
      },
      handleVerifySmsClose() {
        let _self = this;
        _self.issend = false;
        _self.smscode = "";
        _self.smsloading = false;
        _self.miao = 180;
        _self.verifyvalue = "";
        _self.dialogSmsVisible = false;
      },
      initMap() {
        let _self = this;
        _self.$api
          .request(_self.$url.Map.data, _self.$method.get, {
            equipmentNo: _self.search.equipmentNo,
            equipmentName: _self.search.equipmentName
          })
          .then(res => {
            positions = [];
            _self.showPositions = [];
            if (res.code === 0) {
              let totalpositions = res.data;
              for (let i = 0; i < totalpositions.length; i++) {
                totalpositions[i]["show"] = false;
                if (totalpositions[i]["lat"] && totalpositions[i]["lng"]) {
                  positions.push(totalpositions[i]);
                }
                if (_self.showPositions.length < _self.pageSize) {
                  _self.showPositions.push(totalpositions[i]);
                }
              }
              _self.count = positions.length;
              _self.pageIndex = 2;
              _self.rightLoading = false;
              // 获取当前位置信息（经纬度）
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  function (position) {
                    _self.latitude = position.coords.latitude;
                    _self.longitude = position.coords.longitude;
                    _self.loadMaps(_self.latitude, _self.longitude);
                  },
                  function (error) {
                    var errorType = [
                      this.$t("user.MachineMaps.588934-7"),
                      this.$t("user.MachineMaps.588934-8"),
                      this.$t("user.MachineMaps.588934-9")
                    ];
                    console.log(errorType[error.code - 1]);
                    // 开达工业园位置
                    let latitude = 22.977346659551902;
                    let longitude = 113.3884409976354;
                    _self.latitude = latitude;
                    _self.longitude = longitude;
                    _self.loadMaps(latitude, longitude);
                  }
                );
              }
            }
          })
          .catch(() => {
            _self.$notify({
              title: this.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      loadMaps(latitude, longitude, zoom = 3, equipmentNo = "") {
        let _self = this;
        const loader = new Loader({
          apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw", //已替换用户key
          version: "weekly", // 版本
          libraries: ["places"]
        });
        // 定位地图中心点
        let center = { lat: parseFloat(latitude), lng: parseFloat(longitude) };
        loader
          .load()
          .then(google => {
            const mapOptions = {
              disableDefaultUI: true, //禁用控件默认UI
              center: center,
              zoom: zoom,
              gestureHandling: "greedy", //鼠标缩放即可
              mapTypeId: "terrain",
              fullscreenControl: true,
              fullscreenControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
              },
              streetViewControl: true,
              streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
              }
            };
            let map = new google.maps.Map(document.getElementById("mapBox"), mapOptions);
            // 向地图中心点添加（当前位置）标记
            if (parseInt(zoom) == 3) {
              marker = new google.maps.Marker({
                map: map,
                position: center,
                animation: google.maps.Animation.DROP,
                icon: {
                  url: "/img/position.png", // url
                  scaledSize: new google.maps.Size(50, 50)
                },
                optimized: true
              });
            } else {
              // 删除中心点
              marker.setMap(null);
            }
            // 向地图添加聚类标记
            const markers = positions.map(position => {
              const label = position.name;
              // 标记弹框内容{{$t('machine.equipmentNo')}}
              let contentString =
                '<div id="content">' +
                '<div id="siteNotice"></div>' +
                '<h1 id="firstHeading" style="width: 100%; font-size: 18px; text-align: left; margin-bottom: 10px;">' +
                label +
                "</h1>" +
                '<div id="bodyContent" style="text-align: left;">' +
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("user.nickName") +
                "：</strong><label>" +
                position.nickName +
                "</label></div>" +
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("machine.equipmentNo") +
                "：</strong><label>" +
                position.equipmentNo +
                "</label></div>" +
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("machine.position") +
                "：</strong><label>" +
                position.address +
                "</label></div>";
              if (position.online) {
                if (parseInt(position.online) == 0) {
                  contentString +=
                    '<div style="margin-bottom: 6px;"><strong>' +
                    this.$t("machineRecord.state") +
                    '：</strong><label style="color: #04F21C;">' +
                    this.$t("machineRecord.online") +
                    "</label></div>";
                } else if (parseInt(position.online) == 1) {
                  contentString +=
                    '<div style="margin-bottom: 6px;"><strong>' +
                    this.$t("machineRecord.state") +
                    '：</strong><label style="color: #d81e06;">' +
                    this.$t("machineRecord.unline") +
                    "</label></div>";
                }
              } else {
                contentString +=
                  '<div style="margin-bottom: 6px;"><strong>' +
                  this.$t("machineRecord.state") +
                  '：</strong><label style="color: black;">-</label></div>';
              }
              contentString +=
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("machineOrder.allPurchaseNum") +
                "：</strong><label>" +
                position.sales +
                "</label></div>" +
                '<div style="margin-bottom: 6px;"><strong>' +
                this.$t("machineOrder.allDuePrice") +
                "：</strong><label>$" +
                position.amount +
                "</label></div>" +
                "</div>" +
                "</div>";
              const infowindow = new google.maps.InfoWindow({
                content: contentString,
                disableAutoPan: true
              });
              let newposition = {
                lat: parseFloat(position["lat"]),
                lng: parseFloat(position["lng"])
              };
              let icon = "/img/undfine.png";
              if (position.online) {
                if (parseInt(position.online) == 1) {
                  icon = "/img/unline.png";
                } else if (parseInt(position.online) == 0) {
                  icon = "/img/online.png";
                }
              }
              const marker = new google.maps.Marker({
                position: newposition,
                animation: google.maps.Animation.DROP,
                icon: {
                  url: icon,
                  scaledSize: new google.maps.Size(50, 50)
                }
              });
              if (parseInt(zoom) != 3 && equipmentNo == position.equipmentNo) {
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  infowindow.open({
                    anchor: marker,
                    map,
                    shouldFocus: false
                  });
                }, 1000);
              }
              // 标记点击弹框事件
              marker.addListener("click", () => {
                infowindow.open({ anchor: marker, map, shouldFocus: false });
              });
              return marker;
            });
            new MarkerClusterer({ map, markers });
            _self.fullscreenLoading = false;
          })
          .catch(e => {
            _self.fullscreenLoading = false;
            console.log(e);
          });
      },
      handleSendLogMQ(equipmentNo, type) {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.xiazload"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        this.$api
          .request(this.$url.UserMachine.sendMqtt, this.$method.post, {
            equipmentNo,
            type
          })
          .then(res => {
            if (res.code == 0) {
              // this.countError = 0;
              this.actionQuery(equipmentNo, type, loading);
            } else {
              this.$notify({
                title: this.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            this.$notify({
              title: this.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      actionQuery(equipmentNo, type, loading) {
        // // 调用一次++
        // this.countError++;
        // if (this.countError > 20) {
        // 	this.$message.warning(this.$t('user.MachineMaps.588934-10'));
        // 	loading.close();
        // 	return;
        // }
        let _self = this;
        _self.$api
          .request(_self.$url.UserMachine.androidlog, _self.$method.get, {
            equipmentNo,
            type
          })
          .then(res => {
            if (res.code == 0) {
              let records = res.data.records;
              loading.close();
              if (records.length > 0) {
                let url = records[0]["url"];
                window.location.href = url;
              } else {
                _self.$notify({
                  title: _self.$t("common.tip"),
                  message: _self.$t("common.xzcsl"),
                  type: "warning"
                });
              }
            } else if (res.code == 1) {
              // 下载中
              let djs = setTimeout(function () {
                clearTimeout(djs);
                _self.actionQuery(equipmentNo, type, loading);
              }, 3000);
            } else {
              loading.close();
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            this.$notify({
              title: this.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      handleExist(equipmentNo, index) {
        this.$api
          .request(this.$url.UserMachine.control, this.$method.post, {
            equipmentNo: equipmentNo,
            type: "OUT"
          })
          .then(res => {
            if (res.code == 0) {
              this.$notify({
                title: this.$t("common.tcsuccess"),
                message: res.msg,
                type: "success"
              });
              this.showPositions[index]["remoteStatus"] = 3;
              return false;
            } else {
              this.$notify({
                title: this.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            this.$notify({
              title: this.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      //  远程控制
      handleControl(item, index) {
        console.log(1212);
        let _self = this;

        this.nowRemoteInfo = item;
        // 直接远程控制
        this.showPositions[index]["remoteStatus"] = 2;
        const loading = _self.$loading({
          lock: true,
          text: _self.$t("common.ljload"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        _self.$api
          .request(_self.$url.UserMachine.control, _self.$method.post, {
            equipmentNo: item.equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              // 还原次数
              _self.countError = 0;
              //  监听远程控制连接状态
              _self.getYCKZControl(item.equipmentNo, index, loading);
            } else {
              loading.close();
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            loading.close();
            _self.$notify({
              title: _self.$t("common.tip"),
              message: "reqest error",
              type: "warning"
            });
          });
      },
      // Turn on Ethernet
      handleOpenNetwork(item) {
        let _self = this;
        _self.$api
          .request(_self.$url.UserMachine.openNetWork, _self.$method.post, {
            equipmentNo: item.equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              _self.$notify({
                title: "tips",
                message: res.msg,
                type: "success"
              });
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            _self.$notify({
              title: _self.$t("common.tip"),
              message: "reqest error",
              type: "error"
            });
          });
      },
      // Turn off Ethernet
      handleCloseNetwork(item) {
        let _self = this;
        _self.$api
          .request(_self.$url.UserMachine.closeNetWork, _self.$method.post, {
            equipmentNo: item.equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              _self.$notify({
                title: "tips",
                message: res.msg,
                type: "success"
              });
            } else {
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(() => {
            _self.$notify({
              title: _self.$t("common.tip"),
              message: "reqest error",
              type: "error"
            });
          });
      },
      // 延迟函数
      async delay(time) {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, time);
        });
      },

      //  监听远程控制连接状态
      async getYCKZControl(equipmentNo, index, loading) {
        let _self = this;

        await this.delay(3000);
        // 调用一次++
        this.countError++;
        if (this.countError > 20) {
          this.$message.warning(this.$t("user.MachineMaps.588934-10"));
          loading.close();
          if (!(this.nowRemoteInfo.remoteCode && this.nowRemoteInfo.remoteId && this.nowRemoteInfo.gotoHttpUrl)) {
            //超时
            return;
          }
          // 如果有条件 连接失败后拿以前的连接
          //  this.showPositions[index]["remoteState"] = 2;
          this.control.remoteCode = this.nowRemoteInfo.remoteCode;
          this.control.remoteId = this.nowRemoteInfo.remoteId;
          this.control.url = this.nowRemoteInfo.gotoHttpUrl;
          let djs = setTimeout(function () {
            clearTimeout(djs);
            _self.$refs.btnForm.click();
          }, 1000);
          return;
        }
        //  执行连接状态检测
        _self.$api
          .request(_self.$url.UserMachine.getcontrol, _self.$method.get, {
            equipmentNo
          })
          .then(res => {
            if (res.code == 0) {
              if (res.data && res.data.remoteState == 2) {
                loading.close();
                //  连接成功
                _self.showPositions[index]["remoteState"] = 2;
                _self.control.remoteCode = res.data.remoteCode;
                _self.control.remoteId = res.data.remoteId;
                _self.control.url = res.data.gotoHttpUrl;
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  _self.$refs.btnForm.click();
                }, 1000);
                return;
              } else if (res.data && res.data.remoteState == -1) {
                loading.close();
                //  连接失败
                _self.showPositions[index]["remoteState"] = -1;
                _self.$notify({
                  title: _self.$t("common.tip"),
                  message: _self.$t("common.ljfail"),
                  type: "error"
                });
              } else {
                //  连接中
                _self.showPositions[index]["remoteState"] = 1;
                //  休息1秒
                let djs = setTimeout(function () {
                  clearTimeout(djs);
                  _self.getYCKZControl(equipmentNo, index, loading);
                }, 1000);
              }
            } else {
              loading.close();
              //  连接失败
              _self.showPositions[index]["remoteState"] = -1;
              _self.$notify({
                title: _self.$t("common.tip"),
                message: res.msg,
                type: "warning"
              });
            }
          })
          .catch(res => {
            loading.close();
            //  连接失败
            _self.showPositions[index]["remoteState"] = -1;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: JSON.stringify(res),
              type: "error"
            });
          });
      },
      scroll() {
        let _self = this;
        const scrollTop = this.$refs.zuoceDiv.scrollTop;
        // 获取可视区的高度
        const windowHeight = this.$refs.zuoceDiv.clientHeight;
        // 获取滚动条的总高度
        const scrollHeight = this.$refs.zuoceDiv.scrollHeight;
        if (scrollTop + windowHeight >= scrollHeight) {
          // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
          // 调用函数
          this.isShow = true;
          let lindex = _self.pageSize * (_self.pageIndex - 1);
          let j = 0;
          for (let i = 0; i < positions.length; i++) {
            if (i >= lindex && j < 10) {
              j++;
              _self.showPositions.push(positions[i]);
            }
          }
          if (j > 0) {
            console.log("+++++++++++");
            _self.pageIndex++;
          }
          _self.isShow = false;
          console.log(this.$t("user.MachineMaps.588934-11"));
        }
      },
      handleSearch() {
        let _self = this;
        _self.rightLoading = true;
        _self.initMap();
      },
      handleReset() {
        let _self = this;
        _self.rightLoading = true;
        _self.search.equipmentNo = "";
        _self.search.equipmentName = "";
        _self.initMap();
      },
      handleShow(index, type, equipmentNo) {
        let _self = this;
        if (parseInt(type) == 1) {
          // 打开控制面板
          for (let i = 0; i < _self.showPositions.length; i++) {
            if (index == i) {
              let localitem = _self.showPositions[index];
              let show = localitem["show"];
              if (!show) {
                localitem["show"] = true;
              } else {
                localitem["show"] = false;
              }
            } else {
              _self.showPositions[i]["show"] = false;
            }
          }
        } else {
          // 重新定位
          let localitem = _self.showPositions[index];
          let latitude = parseFloat(localitem["lat"]);
          let longitude = parseFloat(localitem["lng"]);
          _self.loadMaps(latitude, longitude, 18, equipmentNo);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog {
    border-radius: 6px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial,
      sans-serif;
    .el-dialog__header {
      padding: 15px 15px 15px 20px;
      background-color: var(--vtm-mint);
      border-radius: 5px 5px 0 0;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
    }
    .el-dialog__title {
      color: white;
    }
    .el-dialog__footer {
      padding: 20px;
    }
    .el-form--label-top .el-form-item__label {
      padding: 0;
    }
    .el-form-item {
      margin: 0;
    }
    .el-dialog__headerbtn {
      top: 20px;
      right: 15px;
    }
  }
  ::v-deep .SmsVerify {
    height: auto !important;
    .el-dialog__body {
      height: auto !important;
      padding: 20px;
    }
  }
  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }

  .el-drawer__wrapper {
    position: absolute;
    display: flow-root;
    margin: 0 26px;
  }

  .el-popover {
    line-height: 2.4;
  }

  .control-btn,
  .network-btn {
    margin: 0 10px 10px 0;
    border: 0;
    font-weight: bold;
    padding: 7px;
    float: left;
  }

  .control-btn {
    background-color: var(--vtm-warn);
    color: var(--vtm-ink);
  }

  ::v-deep .control-btn.is-disabled,
  ::v-deep .control-btn.is-disabled:hover,
  ::v-deep .control-btn.is-disabled:focus {
    background-color: var(--vtm-well);
    color: var(--vtm-ink-3);
    cursor: not-allowed;
    border-color: var(--vtm-line);
  }

  .network-btn {
    color: #ffffff;
  }

  .network-btn--open {
    background-color: var(--vtm-ok);
  }

  .network-btn--close {
    background-color: var(--vtm-crit);
  }
</style>
